import router from '../../shared/router';
import MenuService from '../../core/components/sidebar/MenuService';
import MenuItem from '../../core/components/sidebar/MenuItem';
import ElsaWorkflow from './ElsaWorkflow';

const {routes} = router.options;
const route = routes.find(r => r.path === '/app');

const tmpRoutes = [
  {
    path: 'orchestration',
    name: 'Orchestration',
    component: ElsaWorkflow,
    meta: {
      requiresAuth: true,
    },
  },
];

tmpRoutes.forEach((obj) => {
  route.children.push(obj);
});

router.addRoutes([route]);
// MenuService.addItem(new MenuItem('Orchestration', {
//   path: '/app/orchestration',
//   text: 'Orchestration',
//   uuid: 'Orchestration',
//   permission: 'read',
//   weight: 0,
//   icon: ['fas', 'code-branch']
// }));
